import { render, staticRenderFns } from "./specialHome.vue?vue&type=template&id=6f40cf9c&scoped=true"
import script from "./specialHome.vue?vue&type=script&lang=js"
export * from "./specialHome.vue?vue&type=script&lang=js"
import style0 from "./specialHome.vue?vue&type=style&index=0&id=6f40cf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40cf9c",
  null
  
)

export default component.exports